import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { getDateFormate } from "../../Common/AllDateTimeReleventFormate";

const ContestDetailModal = ({ data }) => {
  const laung = localStorage.getItem("laung");
  const navigate = useNavigate();
  const { setMyorderActiveprojectroute } = useRouteBaseStateContext();

  return (
    <div className="post-modal-details">
      <div className="post-back">
        <div className="col-md-12 ">
          <h3>Contest Details </h3>
          <p> {data?.title} </p>
          {/* <p> <GetRemainDays enddate={data?.ends_on} />  </p> */}
          <p>Due on</p>
          <p>{getDateFormate(data?.last_date)} </p>
        </div>
      </div>
      <button
        onClick={() => {
          navigate(
            `/${laung ?? "en"}/dashboard/managework/contests/active/${
              data.model_id
            }`
          );
        //   /en/dashboard/managework/contests/active/1509
          setMyorderActiveprojectroute("Milestones");
        }}
        className="btn buttons border-button ml-auto mt-3"
      >
        {" "}
        View Details
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
          alt=""
        />
      </button>
    </div>
  );
};

export default ContestDetailModal;
